export function stringComparer(str1: string, str2: string): number {
    if (str1 === str2) {
        return 0;
    }

    if (str1 === null || str1 === undefined) {
        return 1;
    }

    if (str2 === null || str2 === undefined) {
        return -1;
    }

    return str1 > str2 ? 1 : -1;
}